export default __webpack_public_path__ + "static/media/pgmico(14).7fd85655.png";